import React from "react";

const ReRenderContext = React.createContext<any>(null)

export function useReRender(){
return React.useContext(ReRenderContext)
}


export function ReRenderProvider({children}){
    const [rN,setRN] = React.useState<number>(0)
    const reRender = ()=> setRN((state)=>state+1)

    return <ReRenderContext.Provider value={{rN,reRender}}>
        {children}
    </ReRenderContext.Provider>
}
